angular.module("Main").filter("filterTimeKB", function () {
    return function (input, timeFrom, timeTill) {
        var result = [];
        if (input && input.length > 0) {
            _.forEach(input, function (termin) {
                    let from = timeFrom.split(":");
                    let till = timeTill.split(":");
                    let start = termin.Start.split(":");
                    let ende = termin.Ende.split(":");
                    let today = new Date();
                    let timeStartFilter = new Date(today.getFullYear(), today.getMonth(), today.getDate(), from[0], from[1], 0);
                    let timeEndeFilter = new Date(today.getFullYear(), today.getMonth(), today.getDate(), till[0], till[1], 0);
                let timeStart = new Date(today.getFullYear(), today.getMonth(), today.getDate(), start[0], start[1], 0);
                let timeEnde = new Date(today.getFullYear(), today.getMonth(), today.getDate(), ende[0], ende[1], 0);
                    if (timeStart.getTime() >= timeStartFilter.getTime() && timeStart.getTime() <= timeEndeFilter.getTime() && timeEnde.getTime() <= timeEndeFilter.getTime()) {
                        result.push(termin)
                    }
            });

        }

        return result;
    };
});